// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"7b87b21b","687":"5d1b0a97","795":"3999332a"}[chunkId] + ".chunk.js";
};